module.exports = __webpack_public_path__ + "static/img/Oak Shale Grey.d820de9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/Oak Shale Grey.jpg
// module id = 0j0q
// module chunks = 0